import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApplicationId } from '../../../lib';
import { RBR_API_CONFIG, RbrApiConfig } from '../rbr-api.config';
import { ConfigurationFields, Endpoints, ApiLevel, ApiRoom } from '../models';
import { ApiBuilding } from '../models/api/api-building.interface';
import { ApiProject } from '../models/api/api-project.interface';

/**
 * The structure of the request body when patching a project in the VGP API.
 *
 * 🚨 INFO: Building sub-properties can be patched independently, but each patched sub-property
 * must be sent as a complete object (e.g. full levels dictionary or full rooms dictionary).
 * Adding or modifying a single level/room still requires sending the full dictionary for that sub-property.
 */
export interface PatchApiProjectRequest {
    building: ApiBuilding;
}

@Injectable({ providedIn: 'root' })
export class RoomByRoomApiService {
    private readonly baseUrl: string;
    private readonly applicationId: ApplicationId = ApplicationId.ViGuidePlanning;

    constructor(
        @Inject(RBR_API_CONFIG) config: RbrApiConfig,
        private httpClient: HttpClient
    ) {
        this.baseUrl = config.apiBaseUrl;
        this.applicationId = config.applicationId;
    }

    public getConfiguration$(params: { fields: ConfigurationFields[] }): Observable<any> {
        const url = `${this.baseUrl}${Endpoints.Configurations}`;
        return this.httpClient.get(url, { params });
    }

    public getProject$(projectId: string): Observable<ApiProject> {
        const url = `${this.baseUrl}${Endpoints.Projects}/${projectId}`;
        return this.httpClient.get<ApiProject>(url);
    }

    public patchProject$(projectId: string, body: PatchApiProjectRequest): Observable<unknown> {
        const url = `${this.baseUrl}${Endpoints.Projects}/${projectId}`;
        return this.httpClient.patch(url, body);
    }
}
